/* aminos-timeline-steps — on the mobile (vertical) layout, cap the connector
   line so it ends at the centre of the LAST step's marker instead of running
   down past it (step content below the last marker would otherwise extend the
   track). Trimming the line element also bounds the travelling glow, which
   animates 0%–100% of the line. Desktop (horizontal) uses the CSS as-is. */
if (!customElements.get('aminos-timeline-steps')) {
  customElements.define(
    'aminos-timeline-steps',
    class AminosTimelineSteps extends HTMLElement {
      connectedCallback() {
        this.line = this.querySelector('.aminos-timeline-steps__line');
        this.markers = Array.from(this.querySelectorAll('.aminos-timeline-steps__marker'));
        this.mq = window.matchMedia('(max-width: 989px)');
        this._update = () => this.update();

        if (this.mq.addEventListener) {
          this.mq.addEventListener('change', this._update);
        } else if (this.mq.addListener) {
          this.mq.addListener(this._update); // older Safari
        }

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this._update);
          this.ro.observe(this);
        } else {
          window.addEventListener('resize', this._update);
        }

        this.update();
      }

      update() {
        if (!this.line || this.markers.length < 2) return;

        // Desktop: clear any mobile overrides and let the CSS drive it.
        if (!this.mq.matches) {
          this.line.style.height = '';
          this.line.style.bottom = '';
          return;
        }

        const first = this.markers[0].getBoundingClientRect();
        const last = this.markers[this.markers.length - 1].getBoundingClientRect();
        const length = last.top + last.height / 2 - (first.top + first.height / 2);
        if (length > 0) {
          this.line.style.height = length + 'px';
          this.line.style.bottom = 'auto';
        }
      }

      disconnectedCallback() {
        if (this.mq) {
          if (this.mq.removeEventListener) this.mq.removeEventListener('change', this._update);
          else if (this.mq.removeListener) this.mq.removeListener(this._update);
        }
        if (this.ro) this.ro.disconnect();
        else window.removeEventListener('resize', this._update);
      }
    }
  );
}
